export const keysMap = {
  room: 'room',
  addressDdu: 'addressDdu',
  numberDdu: 'numberDdu',
  finishType: 'finishType',
  relation: 'relation',
  type: 'type',
  stage: 'stage',
  step: 'step',
  status: 'status',
  service: 'service',
  desk: 'desk',
  individualStartDate: 'individualStartDate',
  individualEndDate: 'individualEndDate',
  date: 'date',
  actions: 'actions',
  porch: 'porch',
  repeat: 'repeat',
};

export const presetKeysMap = {
  default: 'default',
  addIndividualDates: 'addIndividualDates',
};

export const presetKeys = Object.values(presetKeysMap);

export const presets = {
  [presetKeysMap.default]: [
    keysMap.room,
    keysMap.addressDdu,
    keysMap.numberDdu,
    keysMap.type,
    keysMap.porch,
    keysMap.relation,
    keysMap.stage,
    keysMap.step,
    keysMap.status,
    keysMap.service,
    keysMap.desk,
    keysMap.individualStartDate,
    keysMap.individualEndDate,
    keysMap.date,
    keysMap.repeat,
    keysMap.actions,
  ],

  [presetKeysMap.addIndividualDates]: [
    keysMap.room,
    keysMap.addressDdu,
    keysMap.type,
    keysMap.finishType,
    keysMap.porch,
    keysMap.relation,
    keysMap.stage,
    keysMap.step,
    keysMap.status,
    keysMap.individualStartDate,
    keysMap.individualEndDate,
    keysMap.repeat,
  ],
};
